(function() {
    angular.module('emarket.store.categories', [ 'ui.router' ])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('store.category', {
            url:'/categorias',
            views: {
                store: {
                    controller: 'StoreCategoryController as vm',
                    templateUrl: 'main/category/category.tpl.html'
                }
            }
        });
    }]);
}());

(function() {
    angular.module('emarket.store.categories', [ 'ui.router' ])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('store.category', {
            url:'/categorias',
            views: {
                store: {
                    controller: 'StoreCategoryController as vm',
                    templateUrl: 'main/category/category.tpl.html'
                }
            }
        });
    }]);
}());
